@defer (when percentage) {
  <div class="percentage-bar">
    <div [style]="'width:' + percentage + '%'" class="rating-{{ rating }}" title="Rating is {{ rating }}">{{ percentage }}<span>%</span></div>
  </div>
} @placeholder (minimum 100ms) {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}
